import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SourceSystem } from '@apps/fiduciary/fiduciary.state';
import { TranslateModule } from '@ngx-translate/core';

const taskSourceIconMapping: Record<SourceSystem, string> = {
  Abacus: 'abacus_icon',
  Portal: 'task',
  Sharepoint: 'sharepoint_icon',
};

@Component({
  selector: 'app-task-table-item-title',
  templateUrl: './task-table-item-title.component.html',
  styleUrls: ['./task-table-item-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, TranslateModule],
})
export class TaskTableItemTitleComponent {
  @Input() taskTitle!: string;
  @Input() taskSource!: SourceSystem;

  get svgIcon() {
    return taskSourceIconMapping[this.taskSource];
  }
}
